import qs from 'qs';
import { createResourceApi } from '@/api/resource/api';
import type { Connection, ConnectionDirection, ConnectionId, ConnectionOrigin } from '@/modules/connection/types/connection';

const api = createResourceApi('connection');

export async function connectionGet(id: ConnectionId) {
    return api.get<Connection>(id);
}

export async function connectionGetList(params = {}) {
    return api.post<{
        list: Connection[];
        metadata: {
            count: number;
        };
    }>(undefined, 'list', qs.stringify(params));
}

export async function connectionIsAuthorized(id: ConnectionId) {
    return api.get<{ isAuthorized: boolean }>(id, 'is-authorized');
}

export async function connectionRename(id: ConnectionId, name: string) {
    return api.post<Connection>(id, 'rename', qs.stringify({ name }));
}

export async function connectionGetConnectData(id: ConnectionId, direction: ConnectionDirection, origin: ConnectionOrigin) {
    return api.post(undefined, 'connect-data', qs.stringify({ id, direction, origin }));
}

export async function connectionLink({ id, direction, origin }: {
    id: ConnectionId;
    direction: ConnectionDirection;
    origin: ConnectionOrigin;
}) {
    return api.post<{ link: string }>(id, 'link', { direction, origin });
}

export async function connectionHashGet(hash: string) {
    return api.get<Connection>(hash);
}

export async function connectionHashPost(hash: string) {
    return api.post(hash);
}

export async function connectionConnect(data: object) {
    return api.post<Connection>(undefined, 'connect', qs.stringify(data));
}

export async function connectionDisconnect(id: ConnectionId) {
    return api.get<Connection>(id, 'disconnect');
}
